import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from './authentication.service';
import { jwtDecode } from 'jwt-decode';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const token = sessionStorage.getItem('auth_token');
      if (!token) {
        this.router.navigate(['/'], { queryParams: { returnUrl: state.url } });
        return false;
      }

      const decoded: any = jwtDecode(token);
      const role = Number(decoded.user_role);

      if (route.data['roles'] && route.data['roles'].length > 0) {
        if (route.data['roles'].includes(role)) {
          return true;
        }

        // Super admin (role 0) can access restaurant panel routes when a restaurant is selected
        const isRestaurantRoute = (route.data['roles'] as number[]).some(r => [1, 2, 3, 4].includes(r));
        if (role === 0 && isRestaurantRoute) {
          const hasRestaurant = !!sessionStorage.getItem('restaurant_data');
          if (hasRestaurant) {
            return true;
          }
          // No restaurant selected — send back to admin restaurants list to pick one
          this.router.navigate(['/admin/restaurants']);
          return false;
        }

        if (role === 0) {
          this.router.navigate(['/admin/dashboard']);
        } else if ([1, 2, 3, 4].includes(role)) {
          this.router.navigate(['/restaurant/dashboard']);
        } else {
          this.router.navigate(['/not-found']);
        }
        return false;
      }
      return true;
    } catch (e) {
      this.router.navigate(['/']);
      return false;
    }
  }
}


